import { useTheme } from '@mui/joy'
import { Breakpoint } from '@mui/material/styles'
import { useMedia } from 'react-use'

export const useIsMobile = () => {
    const theme = useTheme()
    return useMedia(`(max-width: ${theme.breakpoints.values.sm}px)`)
}

export const isAboveBreakpoint = (breakpoint: Breakpoint) => {
    const theme = useTheme()
    return useMedia(`(min-width: ${theme.breakpoints.values[breakpoint]}px)`)
}

export const isBelowBreakpoint = (breakpoint: Breakpoint) => {
    const theme = useTheme()
    return useMedia(`(max-width: ${theme.breakpoints.values[breakpoint]}px)`)
}
